import React from "react";
import { Input, Select } from "../Input";
import { Button } from "../Button";
import { connect } from "react-redux";
import language from "../../language";
import { getStorage } from "../../utils/storage";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import validatePhoneNumber from "../../utils/validatePhoneNumber";
import validateEmail from "../../utils/validateEmail";
import api from "../../utils/api";
import moment from "moment";
import { generateInvoiceNumber } from "../../utils/invoice";
import { fetchServiceAccounts } from "../../queries/invoices/serviceAccountsQuery";

class NewInvoice extends React.Component {
  state = {
    error: {},
    referenceNumber: "",
    isSubmitting: false,
    invoiceDate: moment().format("YYYY-MM-DD"),
    dueDate: null,
    items: [],
    customerName: "",
    customerEmail: "",
    serviceAccounts: [],
  };

  componentDidMount = async () => {
    const newInvoiceNumber = generateInvoiceNumber();

    await this.getServiceAccounts();

    this.setState({
      referenceNumber: newInvoiceNumber,
    });

    if (this.props.id) {
      this.setState({
        ...this.props,
      });
    }
  };

  getServiceAccounts = async () => {
    try {
      this.setState({
        isFetchingServiceAccounts: true,
      });

      const data = await fetchServiceAccounts(this.props.defaultLanguage);
      console.log("new invoices:", data);

      this.setState({
        isFetchingServiceAccounts: false,
        serviceAccounts: data,
      });
    } catch (error) {
      this.setState({ isFetchingServiceAccounts: false });
    }
  };

  onChangeInput(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      error,
      [field]: e.target ? e.target.value : e,
    });
  }

  validateForm() {
    let {
      error,
      referenceNumber,
      dateIssued,
      customerName,
      customerEmail,
      customerPhoneNumber,
    } = this.state;

    if (referenceNumber === "") {
      error.referenceNumber =
        language[this.props.defaultLanguage].reference_number_required;
    }

    if (!dateIssued) {
      error.dateIssued =
        language[this.props.defaultLanguage].date_issued_required;
    }

    if (customerName === "") {
      error.customerName =
        language[this.props.defaultLanguage].customer_name_required;
    }

    if (customerEmail !== "" && !validateEmail(customerEmail)) {
      error.customerEmail = language[this.props.defaultLanguage].invalid_email;
    }

    if (customerPhoneNumber === "") {
      error.customerPhoneNumber =
        language[this.props.defaultLanguage].customer_phone_number_required;
    } else if (!validatePhoneNumber(customerPhoneNumber)) {
      error.customerPhoneNumber =
        language[this.props.defaultLanguage].invalid_phone_number;
    }
  }

  onSubmit = async () => {
    await this.validateForm();

    let {
      error,
      customerName,
      customerEmail,
      customerPhoneNumber,
      customerNotes,
      invoiceDate,
      dueDate,
      serviceAccountPublicId,
      items,
      referenceNumber,
    } = this.state;

    const { id } = this.props;

    let user = await getStorage();

    if (Object.keys(error).length === 0) {
      // return (window.location.href = `/invoice/${invoiceNumber}`);
      this.setState({
        isSubmitting: true,
      });

      const options = {
        method: "POST",
        url: `${api("core")}/invoices`,
        data: {
          customerName,
          customerEmail,
          customerPhoneNumber,
          referenceNumber,
          customerNotes,
          invoiceDate,
          dueDate,
          serviceAccountPublicId,
          items,
        },
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + user.accessToken,
        },
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "invoice_update_success"
                : "invoice_added_success"
            ]
          );

          this.props.getData();
          this.props.handleCloseModal();
        })
        .catch((error) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage("error", error);
        });
    }
  };

  handleChangeItemField = (field, index, e) => {
    let { items } = this.state;

    delete items[index].error[field];

    items[index][field] = e.target ? e.target.value : e;

    this.setState({ items });
  };

  renderItemForm = (item, index) => {
    return (
      <div className="row">
        <div className="col-md-4">
          <Input
            label={language[this.props.defaultLanguage].item_name}
            placeholder={
              language[this.props.defaultLanguage].item_name_placeholder
            }
            value={item.name}
            onChange={(e) => this.handleChangeItemField("name", index, e)}
            error={item.error.name}
            required
          />
        </div>
        <div className="col-md-4">
          <Input
            label={language[this.props.defaultLanguage].quantity}
            placeholder={0}
            value={item.quantity}
            onChange={(e) => this.handleChangeItemField("quantity", index, e)}
            error={item.error.quantity}
            required
            type="number"
          />
        </div>
        <div className="col-md-4">
          <Input
            label={language[this.props.defaultLanguage].amount}
            placeholder={0}
            value={item.amount}
            onChange={(e) => this.handleChangeItemField("amount", index, e)}
            error={item.error.name}
            required
            type="number"
          />
        </div>
        <div className="col-md-3">
          <Button
            text={language[this.props.defaultLanguage].remove}
            onPress={() => this.handleRemoveItem(index)}
          />
        </div>
        <div style={{ height: 40 }} />
        <hr />
      </div>
    );
  };

  handleAddItem = () => {
    let { items } = this.state;

    let foundError = false;

    if (items.length > 0) {
      let previous = items.length - 1;
      if (!items[previous].description || items[previous].description === "") {
        items[previous].error["description"] =
          language[this.props.defaultLanguage].item_required;
        foundError = true;
      }

      if (!items[previous].amount || items[previous].amount === "") {
        items[previous].error["amount"] =
          language[this.props.defaultLanguage].amount_required;

        foundError = true;
      }

      if (!items[previous].quantity || items[previous].quantity === "") {
        items[previous].error["quantity"] =
          language[this.props.defaultLanguage].quantity_required;

        foundError = true;
      }
    }
    if (foundError) return this.setState({ items });

    items.push({
      description: "",
      quantity: "",
      amount: "",
      error: {},
    });

    this.setState({ items });
  };

  handleRemoveItem = (index) => {
    let { items } = this.state;

    items.splice(index, 1);

    this.setState({ items });
  };

  render() {
    return (
      <>
        <div className="card-body">
          <div className="row">
            <div className="col-md-4">
              <Input
                label={language[this.props.defaultLanguage].reference_number}
                placeholder={
                  language[this.props.defaultLanguage]
                    .reference_number_placeholder
                }
                value={this.state.referenceNumber}
                onChange={(e) => this.onChangeInput("referenceNumber", e)}
                error={this.state.error.referenceNumber}
                required
              />
            </div>
            <div className="col-md-4">
              <Input
                label={language[this.props.defaultLanguage].invoice_date}
                value={this.state.invoiceDate}
                onChange={(e) => this.onChangeInput("invoiceDate", e)}
                error={this.state.error.invoiceDate}
                type="date"
                disabled
                required
              />
            </div>
            <div className="col-md-4">
              <Input
                label={language[this.props.defaultLanguage].due_date}
                value={this.state.dueDate}
                onChange={(e) => this.onChangeInput("dueDate", e)}
                error={this.state.error.dueDate}
                type="date"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <Input
                label={language[this.props.defaultLanguage].customer_name}
                placeholder={
                  language[this.props.defaultLanguage].customer_name_placeholder
                }
                value={this.state.customerName}
                onChange={(e) => this.onChangeInput("customerName", e)}
                error={this.state.error.customerName}
              />
            </div>
            <div className="col-md-4">
              <Input
                label={language[this.props.defaultLanguage].customer_email}
                placeholder={
                  language[this.props.defaultLanguage]
                    .customer_email_placeholder
                }
                value={this.state.customerEmail}
                onChange={(e) => this.onChangeInput("customerEmail", e)}
                error={this.state.error.customerEmail}
              />
            </div>
            <div className="col-md-4">
              <Input
                label={
                  language[this.props.defaultLanguage].customer_phone_number
                }
                placeholder={
                  language[this.props.defaultLanguage]
                    .customer_phone_number_placeholder
                }
                value={this.state.customerPhoneNumber}
                onChange={(e) => this.onChangeInput("customerPhoneNumber", e)}
                error={this.state.error.customerPhoneNumber}
              />
            </div>
            <div className="col-md-12">
              <Select
                options={this.state.serviceAccounts}
                label={language[this.props.defaultLanguage].service_account}
                placeholder={language[this.props.defaultLanguage].select}
                value={this.state.serviceAccountPublicId}
                onChange={(e) =>
                  this.onChangeInput("serviceAccountPublicId", e)
                }
                error={this.state.error.serviceAccountPublicId}
                isLoading={this.state.isFetchingServiceAccounts}
              />
            </div>
          </div>
        </div>
        <hr />
        <div className="card-body">
          {this.state.items.map((item, i) => {
            return <div key={i}>{this.renderItemForm(item, i)}</div>;
          })}
          <div className="row">
            <div className="col-md-2">
              <Button
                text={language[this.props.defaultLanguage].add_item}
                onPress={this.handleAddItem.bind(this)}
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            type="link"
            className="btn-transparent"
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            isSubmitting={this.state.isSubmitting}
            onPress={this.onSubmit.bind(this)}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewInvoice);
